/**
 * VCloud Information Config
 */
import type { InformationConfig } from '../../types'
import type { VCloudRow } from './types'
import { createColumns } from './columns'
import {
    transformData,
    detectColumnVisibility,
    filterRows,
    getRowClassName,
} from './transform'

// Re-export types
export type { VCloudRow, VCloudColumnVisibility } from './types'

// Re-export helpers for external use
export * from './helpers'

// ============================================================================
// Information Config
// ============================================================================

export const vcloudInformationConfig: InformationConfig<VCloudRow> = {
    createColumns: (options) => {
        return createColumns({
            t: options.t,
            expandedServices: options.expandedServices,
            onToggleExpand: options.onToggleExpand,
            columnVisibility: options.columnVisibility as any,
        })
    },
    transformData: (options) => {
        return transformData({
            service: options.service,
            data: options.data,
            t: options.t,
        })
    },
    filterRows: (rows, expandedServices) => {
        return filterRows(rows, expandedServices)
    },
    detectColumnVisibility: (rows) => {
        return detectColumnVisibility(rows)
    },
    getRowClassName: (row) => {
        return getRowClassName(row)
    },
}
